import { StyleSheet } from "react-native";
import ContentLoader from "react-native-easy-content-loader";
import { List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export const LeaderboardListItemSkeleton = () => {
	const theme = useAppTheme();

	return (
		<List.Item
			title={
				/* @ts-ignore: react-native-easy-content-loader has no types */
				<ContentLoader
					active
					title={false}
					pRows={1}
					pHeight={16}
					pWidth={"100%"}
					containerStyles={styles.usernameContainer}
					paragraphStyles={{
						borderRadius: theme.roundness * 2,
						overflow: "hidden",
					}}
				/>
			}
			left={() => (
				<Box flexDirection="row" alignItems="center" gap={12}>
					{/* @ts-ignore: react-native-easy-content-loader has no types */}
					<ContentLoader
						active
						title={false}
						pRows={1}
						pHeight={20}
						pWidth={28}
						containerStyles={styles.rankContainer}
						paragraphStyles={{
							borderRadius: theme.roundness * 2,
							overflow: "hidden",
						}}
					/>
					{/* @ts-ignore: react-native-easy-content-loader has no types */}
					<ContentLoader
						active
						title={false}
						pRows={1}
						pHeight={36}
						pWidth={36}
						containerStyles={styles.avatarContainer}
						paragraphStyles={{
							borderRadius: 18,
							overflow: "hidden",
						}}
					/>
				</Box>
			)}
			right={() => (
				<Box justifyContent="center" marginLeft={12}>
					{/* @ts-ignore: react-native-easy-content-loader has no types */}
					<ContentLoader
						active
						title={false}
						pRows={1}
						pHeight={28}
						pWidth={56}
						containerStyles={styles.badgeContainer}
						paragraphStyles={{
							borderRadius: 99,
							overflow: "hidden",
						}}
					/>
				</Box>
			)}
			style={styles.container}
		/>
	);
};

const styles = StyleSheet.create({
	container: {
		borderLeftWidth: 3,
		borderColor: "transparent",
		paddingHorizontal: 16,
		paddingVertical: 4,
	},
	rankContainer: {
		paddingHorizontal: 0,
		width: 28,
		marginTop: -8,
	},
	avatarContainer: {
		paddingHorizontal: 0,
		width: 36,
		marginTop: -8,
	},
	usernameContainer: {
		paddingHorizontal: 0,
		marginTop: -8,
	},
	badgeContainer: {
		paddingHorizontal: 0,
		width: 56,
		marginTop: -8,
	},
});
